module.exports = __webpack_public_path__ + "static/media/clubs-jack.0339b1aa.png";